import { type Account, type Schedule } from '../types';

export type ConnectionStep =
  | { name: 'pickSchedule'; account: Account; schedules: Schedule[] }
  | { name: 'activating'; account: Account; schedule: Schedule; schedules: Schedule[] }
  | { name: 'noBookableSchedules'; account: Account; schedules: Schedule[] }
  | { name: 'noSchedules'; account: Account };

export function continuationStep(account: Account, schedules: Schedule[]): ConnectionStep {
  if (schedules.length === 0) return { name: 'noSchedules', account };

  const offerable = schedules.filter((schedule) => schedule.bookable);
  if (offerable.length === 0) return { name: 'noBookableSchedules', account, schedules };

  const [only] = offerable;
  if (offerable.length === 1) {
    return { name: 'activating', account, schedule: only, schedules: offerable };
  }

  return { name: 'pickSchedule', account, schedules: offerable };
}
